// Gestione aggiornamenti Service Worker
export function setupServiceWorkerUpdateHandler() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  let refreshing = false;
  // Tiene traccia se al momento del caricamento esisteva già un controller attivo.
  // Se non c'era, il controllerchange è il primo install (non un aggiornamento)
  // e non serve ricaricare la pagina.
  const hadControllerOnLoad = !!navigator.serviceWorker.controller;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadControllerOnLoad) return; // primo install, nessun reload necessario
    if (refreshing) return;
    refreshing = true;
    console.log('Service Worker aggiornato, ricarico la pagina...');
    window.location.reload();
  });

  // Registra il service worker e controlla gli aggiornamenti
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
        updateViaCache: 'none' // Evita cache del SW stesso
      });

      console.log('Service Worker registrato con successo');

      // Controlla aggiornamenti ogni 60 secondi
      setInterval(() => {
        registration.update();
      }, 60000);

      // Se c'è un service worker in attesa, notifica l'utente
      if (registration.waiting) {
        console.log('Nuova versione disponibile');
        promptUserToRefresh(registration.waiting);
      }

      // Ascolta nuovi service worker in attesa
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('Nuova versione disponibile');
            promptUserToRefresh(newWorker);
          }
        });
      });

      // Forza il check degli aggiornamenti se l'app è stata appena aperta
      if (performance.navigation.type === performance.navigation.TYPE_NAVIGATE) {
        registration.update();
      }
    } catch (error) {
      console.error('Errore durante la registrazione del Service Worker:', error);
    }
  });
}

function promptUserToRefresh(worker: ServiceWorker) {
  // Mostra un messaggio all'utente o aggiorna automaticamente
  // Per ora aggiorniamo automaticamente dopo un breve delay
  console.log('Attivazione nuova versione...');
  
  // Skip waiting e ricarica
  worker.postMessage({ type: 'SKIP_WAITING' });
}

// Gestione errori di caricamento delle risorse
window.addEventListener('error', (event) => {
  // Se c'è un errore di caricamento di un chunk/modulo/CSS, prova a ricaricare
  const errorMessage = event.message || '';
  const isResourceError = errorMessage.includes('Failed to fetch') || 
                         errorMessage.includes('Loading chunk') ||
                         errorMessage.includes('dynamically imported module') ||
                         errorMessage.includes('Unable to preload CSS') ||
                         errorMessage.includes('preload CSS');
  
  // Verifica anche se l'errore è su un elemento <link> o <script>
  const target = event.target as HTMLElement;
  const isAssetError = target && (
    (target.tagName === 'LINK' && target.getAttribute('rel')?.includes('stylesheet')) ||
    (target.tagName === 'SCRIPT')
  );
  
  if (isResourceError || isAssetError) {
    console.warn('Errore di caricamento risorsa, ricarico la pagina...', errorMessage, target);
    
    // Controlla se non abbiamo già ricaricato recentemente
    const lastReload = sessionStorage.getItem('last_reload_time');
    const now = Date.now();
    
    if (!lastReload || (now - parseInt(lastReload)) > 5000) {
      sessionStorage.setItem('last_reload_time', now.toString());
      // Forza il reload con hard refresh per bypassare la cache
      window.location.reload();
    }
  }
}, true);

// Gestione promise rejection per errori di import dinamici
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.message || event.reason?.toString() || '';
  const isModuleError = reason.includes('Failed to fetch') || 
                       reason.includes('dynamically imported module') ||
                       reason.includes('Loading chunk');
  
  if (isModuleError) {
    console.warn('Errore di promise rejection (modulo), ricarico la pagina...', reason);
    
    const lastReload = sessionStorage.getItem('last_reload_time');
    const now = Date.now();
    
    if (!lastReload || (now - parseInt(lastReload)) > 5000) {
      sessionStorage.setItem('last_reload_time', now.toString());
      event.preventDefault(); // Previene il log dell'errore
      window.location.reload();
    }
  }
});

// Gestione della visibilità della pagina per controllare aggiornamenti
document.addEventListener('visibilitychange', async () => {
  if (!document.hidden && 'serviceWorker' in navigator) {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      registration.update();
    }
  }
});
